export default {
  title: "Select Savings Group",
  subtitle: "Choose the group you want to work with.",
  loading: "Loading your groups...",
  emptyTitle: "No active group found",
  emptyMessage: "You are not assigned to any active group.",
  role: "Role",
  select: "Select",
  pleaseWait: "Please wait...",
  logout: "Logout",
  help: "Your selected language will remain active across the system.",
  roles: {
    owner: "Owner",
    admin: "Administrator",
    treasurer: "Treasurer",
    member: "Member",
  },
  errors: {
    tooManyAttempts:
      "Too many attempts. Please wait a minute, then try again.",
    loadFailed: "Failed to load your groups.",
    selectFailed:
      "Failed to select the group. Please try again.",
  },
};
